import React, { useState } from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import styles from '../../styles/AppStyles';

const localStyles = StyleSheet.create({
  textAreaContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  fieldsRow: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: 10,
    marginBottom: 10,
  },
  priceField: {
    flexGrow: 1,
    minWidth: 0,
  },
  currencyField: {
    flexGrow: 1,
    minWidth: 0,
  },
  symbolField: {
    width: 120,
    flexGrow: 0,
  },
  pickerThird: {
    width: '100%',
    height: 40,
    paddingVertical: 0,
    justifyContent: 'center',
    marginBottom: 0,
  },
  symbolPicker: {
    width: '100%',
    height: 40,
    fontSize: 14,
    fontFamily: 'sans-serif',
    fontWeight: '400',
    color: '#fff',
    backgroundColor: '#000',
    paddingLeft: 6,
    borderWidth: 0,
  },
});

interface ProductDetailsProps {
  productDescription: string;
  setProductDescription: (val: string) => void;
  price: string;
  setPrice: (val: string) => void;
  currency: string;
  setCurrency: (val: string) => void;
  currencySymbolPosition: 'left' | 'right';
  setCurrencySymbolPosition: (val: 'left' | 'right') => void;
}

const ProductDetails: React.FC<ProductDetailsProps> = ({
  productDescription,
  setProductDescription,
  price,
  setPrice,
  currency,
  setCurrency,
  currencySymbolPosition,
  setCurrencySymbolPosition,
}) => {

  const [error, setError] = useState('');
  
  const validatePrice = (input: string) => {
    // Allow empty input
    if (input === '') {
      setError('');
      setPrice(input);
      return;
    }
    
    //TODO: Allow only valid price formats. This is a simplified version that allows any numeric input.
    setError('');
    setPrice(input);    

    return;

    // Regular expression to validate price format
    // Allows: numbers, optional decimal point or comma, and up to 2 decimal places
    //const priceRegex = /^(\d+)([.,]?\d{0,2})?$/;
    
    const priceRegex = /^\d{1,3}(,\d{3})*(\.\d{0,2})?$|^\d+(\.\d{0,2})?$|^\d{1,3}(\.\d{3})*(,\d{0,2})?$|^\d+(,\d{0,2})?$/;
    // Check if input matches the pattern
    if (priceRegex.test(input)) {
      setError('');
      setPrice(input);
    } else {
       setError('Please enter a valid price (e.g., 100, 99.99)');

    }
  };

  const formatPrice = (input: string) => {
    // Remove all non-digit characters except commas and points
    const cleaned = input.replace(/[^\d,.]/g, '');
    
    // Ensure only one decimal separator (either comma or point)
    const hasMultipleSeparators = (cleaned.match(/[.,]/g) || []).length > 1;
    
    if (hasMultipleSeparators) {
      // Keep only the first separator
      const firstSeparatorIndex = cleaned.search(/[.,]/);
      const beforeSeparator = cleaned.slice(0, firstSeparatorIndex + 1);
      const afterSeparator = cleaned.slice(firstSeparatorIndex + 1).replace(/[.,]/g, '');
      return beforeSeparator + afterSeparator;
    }
    
    return cleaned;
  };

  const handlePriceChange = (input: string) => {
    const formattedInput = formatPrice(input);
    validatePrice(formattedInput);
  };

  return (
    <View>
      <Text style={styles.sectionTitle}>Product Details</Text>

      <View style={localStyles.textAreaContainer}>
    <TextInput
        style={styles.textArea}
        multiline
        placeholder="Enter the Product Information Here…or Write ‘Translate to [Language]’ To Translate the Content of the Template"
        value={productDescription}
        onChangeText={setProductDescription}
      />
      </View>
  
      <View style={localStyles.fieldsRow}>
        <TextInput
          style={[styles.input, localStyles.priceField, { marginBottom: 0 }]}
          placeholder="Price: ex, 19,99"
          value={price}
          onChangeText={handlePriceChange}
          keyboardType="numeric"
        />
           {error ? <Text style={{ color: '#ff0000' }}>{error}</Text> : null}
        <TextInput
          style={[styles.input, localStyles.currencyField, { marginBottom: 0 }]}
          placeholder="Currency: ex, USD"
          value={currency}
          onChangeText={setCurrency}
        />

        <View style={[styles.creativePickerContainer, localStyles.pickerThird, localStyles.symbolField]}>
          <Picker
            selectedValue={currencySymbolPosition}
            onValueChange={val => setCurrencySymbolPosition(String(val) as 'left' | 'right')}
            style={localStyles.symbolPicker}
            dropdownIconColor="#fff"
            accessibilityLabel="Currency symbol position"
          >
            <Picker.Item label="Left ($19.99)" value="left" color="#fff" />
            <Picker.Item label="Right (19.99$)" value="right" color="#fff" />
          </Picker>
        </View>
      </View>
    </View>
  );
};

export default ProductDetails;
